import {
    UPDATE_USER,
} from '../../actionTypes';

export const updateUser = (json) => {
    return {
        type: UPDATE_USER,
        payload: json
    };
}


// WEBPACK FOOTER //
// ./src/services/user/actions.js